const LOOKER_STATES = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  RUNNING: "RUNNING",
  DONE: "DONE",
  ERROR: "ERROR",
};

export default LOOKER_STATES;
